import React from "react";
import styles from "./stat.module.css";

export default function Stat({ lang, obj, levelFlag, isThin, mainStat }) {
    return (
        <div className={`${styles["stat"]} ${isThin ? `${styles["thin"]}` : ""}`}>
            {obj.type[lang] === "{stat}" ? mainStat : obj.type[lang]}
            &nbsp;<span>+{obj[`${levelFlag}_string`]}</span>
        </div>
    );
}
